import { Environment } from './model'

export const environment: Environment = {
  production: false,
  local: false,
  api: {
    url: 'https://id-dev.privod-bondar.ru/api',
  },
  app: {
    url: 'https://id-dev.privod-bondar.ru',
  },
}
